module.exports = __webpack_public_path__ + "static/media/button2.ae68d83e.png";